var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.295,
    height: 30.262,
    viewBox: "0 0 27.295 30.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assessment",
    transform: "translate(-9.406 -4.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M35.136,75.128l-.416.431a.257.257,0,0,0,.37.356l.416-.431a36.481,36.481,0,0,0,3.67-.821l-3.352-3.23a36.486,36.486,0,0,0-.689,3.7Z",
    transform: "translate(-16.758 -44.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M43.783,44.608l13.2-13.681a1.122,1.122,0,0,0-.028-1.588l-1.729-1.672a1.122,1.122,0,0,0-1.588.028L40.434,41.376ZM54.715,30.639l.6.583L43.872,43.093l-.6-.583ZM54,29.95,42.552,41.816l-.6-.583L53.4,29.367Z",
    transform: "translate(-20.599 -14.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M60.019,20.271h1.762V24.4l1.711-1.776v-3.21a.856.856,0,0,0-.857-.854H59.919a3.671,3.671,0,0,1,.158,1.075A3.6,3.6,0,0,1,60.019,20.271Z",
    transform: "translate(-33.528 -9.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M26.01,13.063h6.161a2.434,2.434,0,1,0,0-4.867h-.538a2.614,2.614,0,1,0-5.093,0H26a2.434,2.434,0,0,0,0,4.867Zm3.08-6.891a1.436,1.436,0,1,1-1.436,1.435,1.436,1.436,0,0,1,1.436-1.435Z",
    transform: "translate(-9.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M10.263,44.26H29.1a.857.857,0,0,0,.857-.857V34.167L28.25,35.945v6.6H11.114V20.271h1.762a3.6,3.6,0,0,1-.054-.636,3.67,3.67,0,0,1,.158-1.075H10.263a.856.856,0,0,0-.857.854V43.4a.857.857,0,0,0,.857.857Z",
    transform: "translate(0 -9.006)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/Assignment.b4b8229e5e4a46f0925880dd46c219fd.svg";
export { ForwardRef as ReactComponent };